import constants from '../../../config/constants.js';
$ const BASE_URL = constants.BASE_URL;
$ const returnTo = typeof input.returnTo === 'string' ? input.returnTo : '';
$ const googleAuthHref = returnTo ? `/auth/google?returnTo=${encodeURIComponent(returnTo)}` : '/auth/google';

<preauth_layout page = "Login | Plixi" description="Log in to your Plixi account. Don't have an account yet? Sign up and grow your Instagram account organically. Get more real likes, comments, followers and boost your engagement." PH_KEY=input.PH_KEY>
    <@title>Login</@title>
    <@head>
        <link rel="canonical" href="https://plixi.com/login" />
        <style>
            .grecaptcha-badge{visibility: collapse !important;}

            .nk-block-title {
                font-size: 1.15rem;
            }
            @media (min-width: 992px) {
                .nk-block-title {
                    font-size: 1.25rem;
                    font-weight: 700;
                }
            }
        </style>
    </@head>
    <@script>
        <!-- <script src="https://www.google.com/recaptcha/api.js?render=6LcHn7sZAAAAAOg53M4LcNPbG5LeLD3uJVKTWdYC"></script> -->
        <script type="text/javascript">
           $(document).ready(function () {
            if (typeof window.plixiClearSurveyIntroDismissSession === 'function') {
                window.plixiClearSurveyIntroDismissSession();
            }
            $("#loginSubmit").on("click", function () {
                if ($('#loginForm').valid()) {
                localStorage.setItem("pricing","true");
                $('#loginForm').unbind('submit').submit();
                } else {
                 localStorage.setItem("pricing","false");
                $('#loginForm').validate(); 
                }
            });

            if(!localStorage.yearly || !localStorage.monthly){
            localStorage.setItem("yearly",false);
            localStorage.setItem("monthly",true);
            }
                $("#country").val(localStorage.country);
            });
        </script>
        <weglot_script/>
    </@script>
    
    <div class="nk-block-head">
        <div class="nk-block-head-content">
            <h1 class="nk-block-title">Log in to Plixi</h1>
        </div>
    </div><!-- .nk-block-head -->

    <flash-alert flash=out.stream.locals.flash></flash-alert>
    
    <div class="form-group">
        <a href=googleAuthHref class="social-login-button btn btn-lg btn-outline-primary btn-block">
            <div style="width:18px;height:23px;" class="social-login-icon abcRioButtonSvgImageWithFallback abcRioButtonIconImage abcRioButtonIconImage18"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18px" height="23px" viewBox="0 0 48 48" class="abcRioButtonSvg"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg></div>
            Sign in with Google
        </a>
    </div>
    <div class="text-center pb-1">
        <h6 class="overline-title overline-title-sap"><span>OR</span></h6>
    </div>

    <form id="loginForm" method="POST" class="form-validate">
        <div class="form-group">
            <div class="form-label-group">
                <label class="form-label" for="email">Email Address</label>
                <!-- <a class="link link-primary link-sm" tabindex="-1" href="#">Need Help?</a> -->
            </div>
            <input type="email" class="form-control form-control-lg" id="email" name="email" placeholder="Enter your email address" required autofocus />
        </div><!-- .foem-group -->
        <div class="form-group">
            <div class="form-label-group">
                <label class="form-label" for="password">Password</label>
                <a class="link link-primary link-sm" tabindex="-1" href="/reset">Forgot password?</a>
            </div>
            <div class="form-control-wrap">
                <a tabindex="-1" href="#" class="form-icon form-icon-right passcode-switch" data-target="password">
                    <em class="passcode-icon icon-show icon ni ni-eye"></em>
                    <em class="passcode-icon icon-hide icon ni ni-eye-off"></em>
                </a>
                <input type="password" class="form-control form-control-lg" id="password" name="password" required placeholder="Enter your password"/>
            </div>
        </div><!-- .foem-group -->
        <input type="text" class="d-none" id="country" name="country"/>
        <if(returnTo)>
            <input type="hidden" name="returnTo" value=returnTo/>
        </if>
        <div class="form-group">
            <button id = "loginSubmit" class="btn btn-lg btn-primary btn-block g-recaptcha" type="submit" data-sitekey="6LcHn7sZAAAAAOg53M4LcNPbG5LeLD3uJVKTWdYC" data-callback="onSubmit" data-badge="bottomright">Log In</button>
        </div>
    </form><!-- form -->
    <!-- <div class="form-note-s2 pt-4">New on our platform? <a href=`${BASE_URL}/pricing`>Create an account</a></div> -->
    <div class="text-center mt-5">
        <span class="fw-500">Don't have an account? <a href=`${BASE_URL}/pricing` style="color:var(--primary);">Start Growing</a></span>
    </div> 
</preauth_layout>